module.exports = __webpack_public_path__ + "static/media/Habitat-For-Hummanity.ee200c8a.svg";